import SEO from "@/components/SEO";
import FAQAccordion from "@/components/FAQAccordion";
import { RelatedLinks } from "@/pages/ServicePage";
import { PageHero, SectionHead, CTABand, Reveal } from "@/components/Ui";
import { CheckCircle2 } from "lucide-react";

const prestations = [
  "Maçonnerie générale : murs porteurs, murets, façades",
  "Gros œuvre : fondations, dalles, élévation des murs",
  "Construction de murs en parpaing, brique ou biobrique",
  "Dalles béton, chapes, béton lissé ou désactivé",
  "Ouvertures de murs porteurs et création de baies",
  "Extensions, garages et agrandissements",
  "Terrasses, allées et aménagements extérieurs",
  "Réparations et reprises de maçonnerie",
];

const faq = [
  { q: "Intervenez-vous vraiment sur Évreux ?", a: "Oui : notre entreprise est basée à Évreux, rue Jean de la Fontaine. C'est l'un de nos secteurs principaux, avec Bernay — déplacement rapide et visite gratuite pour votre devis." },
  { q: "Quels chantiers réalisez-vous à Évreux ?", a: "Constructions neuves, extensions, dalles et terrasses béton, murs et clôtures, ouvertures de murs porteurs, rénovation de maçonnerie — pour particuliers et professionnels." },
  { q: "Comment obtenir un devis à Évreux ?", a: "Appelez le 07 45 04 91 89 ou remplissez le formulaire : nous passons voir votre projet sur place, puis nous vous remettons un devis gratuit et détaillé." },
];

export default function MaconnerieEvreux() {
  return (
    <>
      <SEO
        title="Maçonnerie à Évreux | Entreprise de maçonnerie Eure – DMZ Normandie"
        description="DMZ Normandie, entreprise de maçonnerie basée à Évreux : murs, fondations, dalles béton, extensions, gros œuvre. Devis gratuit — 07 45 04 91 89."
        path="/maconnerie-evreux"
      />
      <PageHero
        title="Maçonnerie à Évreux"
        subtitle="DMZ Normandie est basée à Évreux même, rue Jean de la Fontaine. Nous réalisons vos travaux de maçonnerie sur Évreux et sa métropole : construction, gros œuvre, murs, dalles et extensions."
      />

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-14">
          <Reveal>
            <SectionHead overline="Nos prestations" title="Un maçon basé à Évreux" />
            <div className="space-y-4 -mt-6">
              {prestations.map((p) => (
                <p key={p} className="flex items-start gap-3 text-zinc-300 font-light">
                  <CheckCircle2 size={18} className="text-[#C4A484] mt-0.5 shrink-0" /> {p}
                </p>
              ))}
            </div>
            <div className="mt-10">
              <a href="/contact" className="btn-sable" data-testid="cta-devis-evreux">Demander un devis de maçonnerie</a>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="space-y-6">
            <div className="overflow-hidden relative">
              <img src="/realisations/maison-parpaing-plain-pied.webp" alt="Entreprise de maçonnerie à Évreux : élévation d'une maison en parpaings par DMZ Normandie" className="w-full h-72 object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-black/25" />
            </div>
            <div className="card-dark p-8">
              <h2 className="font-serif-display font-light text-2xl md:text-3xl text-[#F5F5F0] mb-4">De la maison de ville au pavillon neuf</h2>
              <p className="text-sm font-light text-zinc-400 leading-relaxed">
                À Évreux, nous travaillons aussi bien sur les maisons anciennes des quartiers centraux
                (reprises de maçonnerie, ouvertures, rénovation) que sur les constructions neuves des
                communes voisines : fondations, élévation en parpaing ou brique, dalles et terrasses.
              </p>
              <p className="mt-4 text-sm font-light text-zinc-400 leading-relaxed">
                Chaque projet commence par une visite gratuite sur place : nous étudions le bâti ou le
                terrain, nous vous conseillons sur les matériaux, puis nous chiffrons poste par poste.
              </p>
            </div>
          </Reveal>
        </div>

        <div className="max-w-4xl mx-auto px-6 lg:px-10 mt-20">
          <SectionHead overline="Questions fréquentes" title="Vos questions, nos réponses" />
          <FAQAccordion items={faq} testid="faq-evreux" />
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16">
          <Reveal>
            <p className="text-[10px] tracking-[0.5em] uppercase text-[#C4A484] mb-5">Voir aussi</p>
            <RelatedLinks slugs={["renovation-evreux", "gros-oeuvre", "extension-maison", "dalles-beton", "zones"]} />
          </Reveal>
        </div>
      </section>

      <CTABand />
    </>
  );
}
